import GlobalConstraints from 'pages/GlobalConstraints';
import autoformPlaceholder from '../images/autoform-unselected.png';
import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import AutoformContainer from 'components/autoform/AutoformContainer';

export const globalConstraintsRoutes = {
    path: '/global-constraints',
    element: <GlobalConstraints />,
    children: [
        {
            index: true,
            element: <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />,
        },
        {
            path: ':itemId',
            element: <AutoformContainer />,
        },
    ],
};
